/**
 * KnowledgeFooter — the simple centered teal footer at the bottom of every
 * Knowledge Center page (mockup's `.fsimple .fbot`).
 */

import styled from 'styled-components';

const Foot = styled.footer`
  background: ${({ theme }) => theme.colors.primary.dark};
  margin-top: ${({ theme }) => theme.spacing[2]};
  padding: ${({ theme }) => theme.spacing[6]} 0;
`;

const Wrap = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing[8]};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[3]};
  flex-wrap: wrap;
  text-align: center;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.72);
`;

const Sep = styled.span`
  color: rgba(255, 255, 255, 0.4);
`;

const MailLink = styled.a`
  color: rgba(255, 255, 255, 0.86);
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};

  &:hover {
    color: ${({ theme }) => theme.colors.text.white};
  }
`;

export function KnowledgeFooter() {
  return (
    <Foot>
      <Wrap>
        <span>© 2026 Upskill ABA Solutions LLC</span>
        <Sep aria-hidden="true">|</Sep>
        <MailLink href="mailto:support@upskillaba.com">support@upskillaba.com</MailLink>
      </Wrap>
    </Foot>
  );
}

export default KnowledgeFooter;
